var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1e233e",
    fillRule: "nonzero",
    stroke: "#1e233e",
    strokeWidth: 0.75,
    d: "M7.839.522L4.49 3.87 1.144.522l-.63.63L3.86 4.5.513 7.848l.63.63L4.492 5.13 7.84 8.478l.63-.63L5.122 4.5l3.347-3.348z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXPurple);
export default __webpack_public_path__ + "static/media/x-purple.d789ec41ada29cc060e4ec8cb1acebfb.svg";
export { ForwardRef as ReactComponent };